import { ref, type Ref } from 'vue'
import { PageLoading } from '@/utils/page-loading-service'
import type { PageLoadingInstance } from '@/utils/page-loading-service'

const pageLoadingVisible: Ref<boolean> = ref(false)
let currentLoadingInstance: PageLoadingInstance | null = null

/**
 * 全局页面 loading 控制
 * @returns loading 控制方法和状态
 */
export const usePageLoading = () => {
  const showPageLoading = () => {
    if (!currentLoadingInstance) {
      currentLoadingInstance = PageLoading.service()
      pageLoadingVisible.value = true
    }
  }

  const hidePageLoading = () => {
    if (currentLoadingInstance) {
      currentLoadingInstance.close()
      currentLoadingInstance = null
      pageLoadingVisible.value = false
    }
  }

  return {
    pageLoadingVisible,
    showPageLoading,
    hidePageLoading,
  }
}
